import React from 'react';
import PasajeroFormulario from './PasajeroFormulario'

import { toolsAPI } from '../../../utils/funcionesAPI'
import {manejadorDeRespuesta, calcularEdad} from '../../../utils/Tools'
import PropTypes from 'prop-types';
import LoaderFormal from '../../Global/LoaderFormal'
import {toast } from 'react-toastify'

class CargaPasajeros extends React.Component {
    constructor(props) {
        super(props)

        this.state = {tiposDocumento: [], nacionalidades: [], loaded: true}

        this.handlePasajeroAdultoChange = this.handlePasajeroAdultoChange.bind(this);
        this.handlePasajeroMenorChange = this.handlePasajeroMenorChange.bind(this);
        this.handlePasoPagarClick = this.handlePasoPagarClick.bind(this);
        //this.handleVolverClick = this.handleVolverClick.bind(this);
        //this.handleSubmit = this.handleSubmit.bind(this);

    }


    componentDidMount() {

      //const { from } = this.props.location.state || { from: { pathname: '/' } }
    /*  const { redirectToReferrer } = this.state


       if (redirectToReferrer) {
           this.props.history.push('/login')
           return;
       }*/

        window.scrollTo(0,0);
        //const tokenEnSesion = sessionStorage.getItem('token');
        const _this = this;
        let data = JSON.stringify({accion: 'tiposDeDocumento'});
        toolsAPI(data)
                .then(respuesta => {
                    if (manejadorDeRespuesta(this.props, respuesta))
                      _this.setState({tiposDocumento: respuesta.data});
                });

        data = JSON.stringify({accion: 'paises'});
        toolsAPI(data)
                .then(respuesta => {
                if (manejadorDeRespuesta(this.props, respuesta))
                    _this.setState({nacionalidades: respuesta.data, loaded: false});

                });

        //FC: borro si tenia algo
        //stockEnDemanda(9);
        //FC: inserto la nueva ocupacion
        //stockEnDemanda(1);
      //  window.scrollTo(0,0);
    }

    handlePasajeroAdultoChange(indice, propiedad, valor) {
        this.props.onPasajeroAdultoChange(indice, propiedad, valor);
    }

    handlePasajeroMenorChange(indice, propiedad, valor) {
        this.props.onPasajeroMenorChange(indice, propiedad, valor);
    }


    handlePasoPagarClick(e) {
      e.preventDefault();

    if (!this.validarDatosCompletos(this.props.pasajerosAdultos) || !this.validarDatosCompletos(this.props.pasajerosMenores)) {
      toast.error('Debe completar todos los campos de los pasajeros', {
                            position: toast.POSITION.BOTTOM_CENTER
                            });
      return;
    }

    if (!this.validarEdadAdultos(this.props.pasajerosAdultos)) {
      toast.error('Los adultos deben ser mayores de 2 años', {
                            position: toast.POSITION.BOTTOM_CENTER
                            });
      return;
    }

    if (!this.validarEdadMenores(this.props.pasajerosMenores)) {
      toast.error('No coincide la edad del menor declarada con la fecha de nacimiento', {
                            position: toast.POSITION.BOTTOM_CENTER
                            });
      return;
    }

      this.props.onPasoPagarClick();
    }

    validarDatosCompletos(pasajeros) {
      //const {pasajerosAdultos, pasajerosMenores} = this.props;
      let rto = true;
      pasajeros.forEach(function(unPasajero) {
        for (var key in unPasajero) {
          if (!unPasajero.hasOwnProperty('nombre') || !unPasajero.hasOwnProperty('apellido')
              || !unPasajero.hasOwnProperty('telefono') || !unPasajero.hasOwnProperty('fechaNacimiento') || !unPasajero.hasOwnProperty('documento') 
              || !unPasajero.hasOwnProperty('tipoDocumento'))
          {
            rto = false;
          }

          if ( (key === 'nombre' && unPasajero[key] === '') || (key === 'apellido' && unPasajero[key] === '') ||
               (key === 'telefono' && unPasajero[key] === '') || (key === 'fechaNacimiento' && unPasajero[key] === '') || (key === 'documento' && unPasajero[key] === '')) {
          rto = false;
          }
        }

      })
      return rto;
    }

  validarEdadMenores(pasajeros) {
    let rto = true;
    pasajeros.forEach(function(unPasajero) {
        let edad = calcularEdad(unPasajero.fechaNacimiento);
        if (Number(unPasajero.edad) !== edad) {
            rto = false;
        }

    })
    return rto;
  }

  validarEdadAdultos(pasajeros) {
    let rto = true;
    pasajeros.forEach(function(unPasajero) {
        let edad = calcularEdad(unPasajero.fechaNacimiento);
        if (edad < 2) {
            rto = false;
        }

    })
    return rto;
  }

    render() {

      let {busqueda, pasajerosAdultos, pasajerosMenores }  = this.props;

      //let producto = JSON.parse(sessionStorage.getItem('producto'));
      //producto.charters = [];
    //  const charter = JSON.parse(sessionStorage.getItem('charter'));

        return (
          <div className="">
            <LoaderFormal loaded={this.state.loaded} />
              <div className="title">
                 <h2>Datos de los pasajeros </h2>
                 <p><sup>*</sup> Datos obligatorios</p>
                 <hr />
               </div>
                <p className="parrafoCargaPasajeros">Pasajeros: {pasajerosAdultos.length} Adultos y {pasajerosMenores.length} Menores. Para cambiar la cantidad de pasajeros, realice una nueva busqueda desde el paso previo</p>
                {
                  pasajerosAdultos.map((pasajero, clave) => {
                    return <PasajeroFormulario  key={clave} numero={clave} busqueda={busqueda}
                      pasajero={pasajero} onPasajeroChange={this.handlePasajeroAdultoChange}
                      tiposDeDocumento={this.state.tiposDocumento}
                      nacionalidades={this.state.nacionalidades}  />
                  })
                }

                {
                  pasajerosMenores.map((pasajero, clave) => {
                    return <PasajeroFormulario  key={clave} numero={clave} busqueda={busqueda}
                      pasajero={pasajero} onPasajeroChange={this.handlePasajeroMenorChange}
                      tiposDeDocumento={this.state.tiposDocumento}
                      nacionalidades={this.state.nacionalidades}  />
                  })
                }
                <input type="submit" value="continuar" className="submitCargaPasajeros" onClick={this.handlePasoPagarClick} />
          </div>
        );
    }
}

export default CargaPasajeros

CargaPasajeros.propTypes = {
  busqueda: PropTypes.object,
  pasajerosAdultos: PropTypes.array,
  pasajerosMenores: PropTypes.array,
  producto: PropTypes.object,
  charter: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/CargaPasajeros/index.js